module.exports = __webpack_public_path__ + "img/img-vocabulary.724cfbd7.svg";